export function escapeStringForContext (dynamicString) {
  return dynamicString.replace(/["\\]/g, '\\$&')
}

export function unescapeCustomString (escapedString) {
  let unescaped = escapedString.replace(/\\"/g, '"')
  unescaped = unescaped.replace(/\\\\/g, '\\')
  return unescaped
}
